module.exports = __webpack_public_path__ + "img/icon_3_37.fdd7fd0a.png";